<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Thêm học sinh vào điểm dừng "{{ busStop.address }}"</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <GradeClassStudentSelect ref="gcsSelect" @changed="gradeClassStudentChange" />
        <div class="py-1 my-0">
          <v-checkbox v-model="selectDaysOfTheWeek" label="Thêm tất cả các ngày trong tuần" hide-details />
        </div>
        <div class="py-1 my-0" v-if="selectDaysOfTheWeek">
          <v-checkbox v-model="isDefaultAbsent" label="Mặc định không đi" hide-details />
          <div v-if="selectDaysOfTheWeek" class="mt-3">
            <BusDOWAutocomplete v-model="defaultAbsents" label="Chọn ngày không đi" />
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-4 px-6">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import BusDOWAutocomplete from './BusDOWAutocomplete.vue'
import { get } from 'lodash'

export default {
  components: {
    GradeClassStudentSelect,
    BusDOWAutocomplete,
  },
  data() {
    return {
      selectedGrade: null,
      selectedClass: null,
      selectedStudent: null,
      dialog: false,
      selectDaysOfTheWeek: false,
      isDefaultAbsent: false,
      defaultAbsents: [],
    }
  },
  props: {
    state: Boolean,
    busStop: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('constant', ['busTimelines']),
    ...mapState('busDetail', ['busData']),
  },
  methods: {
    ...mapActions('busDetail', ['updateStudentBusStop']),
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    cancel() {
      this.$refs.gcsSelect.reset()
      this.dialog = false
      this.selectDaysOfTheWeek = false
    },
    async save() {
      if (!this.$refs.gcsSelect.validate()) return
      this.$loading.active = true
      try {
        await this.updateStudentBusStop({
          id: this.busStop.id,
          student: this.selectedStudent.id,
          selectDaysOfTheWeek: this.selectDaysOfTheWeek,
          address: this.busStop.address,
          direction: get(this.busStop, 'busSchedule.direction'),
          periodTime: get(this.busStop, 'busSchedule.periodTime'),
          isDefaultAbsent: this.isDefaultAbsent,
          defaultAbsents: this.defaultAbsents,
        })
        this.$alert.success('Thêm mới học sinh thành công')
        this.$refs.gcsSelect.reset()
        this.dialog = false
        this.selectDaysOfTheWeek = false
      } catch (error) {
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
